export const mockResources = [
  {
    id: 'res-1',
    type: 'TOOL',
    title: 'BESS Savings & Sizing Calculator',
    summary: 'Model storage economics for peak-shaving and arbitrage across tariff structures.',
    body: 'Interactive tool to calculate battery energy storage system sizing and savings based on your load profile and tariff structure.',
    fileUrl: null,
    externalUrl: null,
    sourceOrg: 'GEA',
    technologies: ['BESS'],
    regions: ['Global'],
    themes: ['Storage Economics', 'Procurement'],
    publishedAt: '2026-05-15',
    isPremium: false
  },
  {
    id: 'res-2',
    type: 'POLICY',
    title: 'Grid Code Reform: A Regulator\'s Playbook',
    summary: 'Benchmarking enabling frameworks for variable renewables across 12 markets.',
    body: 'Comprehensive guide for regulators on updating grid codes to accommodate variable renewable energy sources.',
    fileUrl: '/docs/grid-code-playbook.pdf',
    sourceOrg: 'GEA + IEA',
    technologies: ['Grid Modernization', 'Policy'],
    regions: ['Global'],
    themes: ['Regulation', 'Grid Code'],
    publishedAt: '2026-04-20',
    isPremium: false
  },
  {
    id: 'res-3',
    type: 'PROCUREMENT',
    title: 'Model Tender Document — Utility-Scale Storage',
    summary: 'Editable RFP template with evaluation criteria and risk-allocation matrix.',
    body: 'Complete tender documentation for procuring utility-scale battery storage systems.',
    fileUrl: '/docs/model-tender-bess.pdf',
    sourceOrg: 'GOTF',
    technologies: ['BESS'],
    regions: ['Sub-Saharan Africa', 'South Asia'],
    themes: ['Procurement', 'Contracting'],
    publishedAt: '2026-03-10',
    isPremium: false
  },
  {
    id: 'res-4',
    type: 'MARKET_INTEL',
    title: 'Storage Cost Benchmarks 2026',
    summary: 'Live price index embedded from Bloomberg NEF.',
    body: 'Real-time battery storage cost data and forecasts.',
    externalUrl: 'https://about.bnef.com',
    sourceOrg: 'Bloomberg NEF',
    technologies: ['BESS'],
    regions: ['Global'],
    themes: ['Market Intelligence', 'Pricing'],
    publishedAt: '2026-06-01',
    isPremium: true
  },
  {
    id: 'res-5',
    type: 'POLICY',
    title: 'Mini-grid Regulatory Framework Guide',
    summary: 'Policy templates for enabling mini-grid deployment in emerging markets.',
    body: 'Step-by-step guide for regulators to create supportive mini-grid policies.',
    fileUrl: '/docs/minigrid-framework.pdf',
    sourceOrg: 'SEforALL',
    technologies: ['Mini-grids'],
    regions: ['Sub-Saharan Africa', 'South Asia'],
    themes: ['Policy', 'Off-grid'],
    publishedAt: '2026-02-15',
    isPremium: false
  },
  {
    id: 'res-6',
    type: 'TOOL',
    title: 'Grid Digitization Readiness Assessment',
    summary: 'Self-assessment tool for utilities to evaluate their digitalization preparedness.',
    body: 'Interactive checklist covering SCADA, AMI, data infrastructure, and organizational readiness.',
    sourceOrg: 'World Bank ESMAP',
    technologies: ['Grid Digitization', 'SCADA'],
    regions: ['Global'],
    themes: ['Digital Infrastructure', 'Utility Transformation'],
    publishedAt: '2026-04-05',
    isPremium: false
  }
];
